import {
  BookingConfig,
  BookingConfigEnum,
  VisualVariant,
} from '../../components/BookingWidget/bookingSteps.interface';

export interface VisualValues {
  primaryColor: string;
  secondaryColor: string;
  darkPrimaryColor: string;
  darkSecondaryColor: string;
  darkLightColor: string;
  secondaryLightColor: string;
  sectionTitleColor: string;
  iconAvailableColor: string;
  iconNotAvailableColor: string;
  buttonRadius: string;
  quotationButtonRadius: string;
  outlinedInputRadius: string;
  textFieldRadius: string;
  toggleGroupRadius: string;
  proposalGroupedButtonRadius: string;
  proposalTableCardRadius: string;
  proposalTableBorder: string;
  proposalTableHoverBorder: string;
  proposalTooltipRadius: string;
  proposalTooltipPadding: string;
  proposalTooltipOffset: string;
  proposalTableDescriptionRadius: string;
  proposalTableDescriptionPadding: string;
  proposalPromoMessagePadding: string;
  proposalLinkColor: string;
  proposalLinkTextDecoration: string;
  borderStandardColor: string;
  outlineButtonColor: string;
  outlineButtonFontWeight: string;
  outlineButtonMobileTextTransform: string;
  actionButtonWidth: string;
  actionButtonMaxWidth: string;
  productCardButtonMinWidth: string;
  tripTypeButtonPadding: string;
  submitButtonPadding: string;
  travellerAgeInputHeight: string;
  summaryTextColor: string;
  summaryLabelColor: string;
  summarySectionTitleColor: string;
  summaryQuoteIdColor: string;
  summarySectionTitleFontSize: string;
  summaryPriceColor: string;
  summaryCardBorder: string;
  summaryCardRadius: string;
  summaryBoxMarginBottom: string;
  tripTypeInactiveColor: string;
  travellerMutedColor: string;
  travellerIconButtonBorder: string;
  travellerIconButtonColor: string;
  travellerIconButtonHoverBg: string;
  travellerIconButtonBg: string;
  travellerIconButtonRadius: string;
  travellerIconButtonSize: string;
  agentScriptBackground: string;
  agentScriptShadow: string;
  agentScriptPadding: string;
  agentScriptOpacity: string;
  productCardButtonRadius: string;
  summaryDividerMargin: string;
}

export const legacyVisualValues: VisualValues = {
  primaryColor: '#0072EA',
  secondaryColor: '#0a76ec',
  darkPrimaryColor: '#333',
  darkSecondaryColor: '#666666',
  darkLightColor: '#b9b4b4ad',
  secondaryLightColor: '#0072EA',
  sectionTitleColor: '#333',
  iconAvailableColor: 'green',
  iconNotAvailableColor: '#d01313',
  buttonRadius: '10px',
  quotationButtonRadius: '10px',
  outlinedInputRadius: '1rem',
  textFieldRadius: '0.7rem',
  toggleGroupRadius: '1rem',
  proposalGroupedButtonRadius: '12px',
  proposalTableCardRadius: '12px',
  proposalTableBorder: '1px solid var(--dark-light)',
  proposalTableHoverBorder: '2px solid var(--dark-light)',
  proposalTooltipRadius: '1rem',
  proposalTooltipPadding: '12px 16px',
  proposalTooltipOffset: '4px',
  proposalTableDescriptionRadius: '4px',
  proposalTableDescriptionPadding: '8px 16px',
  proposalPromoMessagePadding: '8px',
  proposalLinkColor: 'var(--secodary-light)',
  proposalLinkTextDecoration: 'underline',
  borderStandardColor: 'var(--dark-light)',
  outlineButtonColor: '#212121',
  outlineButtonFontWeight: '500',
  outlineButtonMobileTextTransform: 'capitalize',
  actionButtonWidth: 'auto',
  actionButtonMaxWidth: 'none',
  productCardButtonMinWidth: 'auto',
  tripTypeButtonPadding: '8px',
  submitButtonPadding: '6px 16px',
  travellerAgeInputHeight: '12px',
  summaryTextColor: 'var(--dark-primary)',
  summaryLabelColor: '#737373',
  summarySectionTitleColor: 'var(--dark-primary)',
  summaryQuoteIdColor: 'var(--dark-secondary)',
  summarySectionTitleFontSize: 'var(--font-title)',
  summaryPriceColor: 'var(--secondary-light)',
  summaryCardBorder: '1px solid var(--dark-light)',
  summaryCardRadius: '0.75rem',
  summaryBoxMarginBottom: '0.4rem',
  tripTypeInactiveColor: 'inherit',
  travellerMutedColor: '#909090',
  travellerIconButtonBorder: '1px solid #b9b4b4ad',
  travellerIconButtonColor: 'black',
  travellerIconButtonHoverBg: '#f5f5f5c7',
  travellerIconButtonBg: 'transparent',
  travellerIconButtonRadius: '50%',
  travellerIconButtonSize: '40px',
  agentScriptBackground: '#6666661f',
  agentScriptShadow: 'none',
  agentScriptPadding: '0.5rem',
  agentScriptOpacity: '0.75',
  productCardButtonRadius: '12px',
  summaryDividerMargin: '0.5rem 0',
};

export const refreshVisualValues: VisualValues = {
  primaryColor: '#3A416F',
  secondaryColor: '#3A416F',
  darkPrimaryColor: '#686868',
  darkSecondaryColor: '#2E2E2E',
  darkLightColor: '#3A416F',
  secondaryLightColor: '#3A416F',
  sectionTitleColor: '#686868',
  iconAvailableColor: '#838383',
  iconNotAvailableColor: '#9D9D9D',
  buttonRadius: '6px',
  quotationButtonRadius: '6px',
  outlinedInputRadius: '6px',
  textFieldRadius: '6px',
  toggleGroupRadius: '1rem',
  proposalGroupedButtonRadius: '6px',
  proposalTableCardRadius: '12px',
  proposalTableBorder: '1px solid var(--dark-light)',
  proposalTableHoverBorder: '2px solid var(--dark-light)',
  proposalTooltipRadius: '1rem',
  proposalTooltipPadding: '12px 16px',
  proposalTooltipOffset: '4px',
  proposalTableDescriptionRadius: '4px',
  proposalTableDescriptionPadding: '8px 16px',
  proposalPromoMessagePadding: '8px',
  proposalLinkColor: 'var(--link-button-color)',
  proposalLinkTextDecoration: 'none',
  borderStandardColor: '#D1D1D1',
  outlineButtonColor: 'var(--secodary-light)',
  outlineButtonFontWeight: '700',
  outlineButtonMobileTextTransform: 'uppercase',
  actionButtonWidth: '100%',
  actionButtonMaxWidth: '182px',
  productCardButtonMinWidth: '182px',
  tripTypeButtonPadding: '0.5rem',
  submitButtonPadding: '0 30px',
  travellerAgeInputHeight: '3rem',
  summaryTextColor: '#161616',
  summaryLabelColor: '#161616',
  summarySectionTitleColor: '#888888',
  summaryQuoteIdColor: '#161616',
  summarySectionTitleFontSize: '1.3rem',
  summaryPriceColor: '#161616',
  summaryCardBorder: 'transparent',
  summaryCardRadius: '1rem',
  summaryBoxMarginBottom: '0.5rem',
  tripTypeInactiveColor: '#909090',
  travellerMutedColor: '#909090',
  travellerIconButtonBorder: '1px solid var(--dark-light)',
  travellerIconButtonColor: 'var(--light-primary)',
  travellerIconButtonHoverBg: 'var(--primary)',
  travellerIconButtonBg: 'var(--secodary-light)',
  travellerIconButtonRadius: '6px',
  travellerIconButtonSize: '3rem',
  agentScriptBackground: '#ffffff',
  agentScriptShadow: '1px 3px 20px 0px #00000017',
  agentScriptPadding: '1rem',
  agentScriptOpacity: '1',
  productCardButtonRadius: '6px',
  summaryDividerMargin: '0.5rem 0',
};

const getBrandVariantFallback = (brandHint: string): VisualVariant =>
  brandHint.toLowerCase().includes('wl') ? 'legacy' : 'refresh';

export const getVisualVariant = (
  bookingConfigData: BookingConfig,
  brandHint = '',
  hasAgentId = false,
): VisualVariant => {
  const configuredVariant = bookingConfigData[BookingConfigEnum.VisualVariant];

  if (configuredVariant) {
    return configuredVariant;
  }

  if (hasAgentId) {
    return 'refresh';
  }

  const configBrand = bookingConfigData[BookingConfigEnum.Brand] || '';

  return getBrandVariantFallback(configBrand || brandHint);
};

export const getVisualValues = (visualVariant: VisualVariant): VisualValues =>
  visualVariant === 'legacy' ? legacyVisualValues : refreshVisualValues;

export const applyVisualCssVariables = (visualValues: VisualValues): void => {
  const root = document.documentElement;

  root.style.setProperty('--primary', visualValues.primaryColor);
  root.style.setProperty('--secondary', visualValues.secondaryColor);
  root.style.setProperty('--dark-primary', visualValues.darkPrimaryColor);
  root.style.setProperty('--dark-secondary', visualValues.darkSecondaryColor);
  root.style.setProperty('--dark-light', visualValues.darkLightColor);
  root.style.setProperty('--secondary-light', visualValues.secondaryLightColor);
  root.style.setProperty('--secodary-light', visualValues.secondaryLightColor);
  root.style.setProperty(
    '--section-title-color',
    visualValues.sectionTitleColor,
  );
  root.style.setProperty('--icon-available', visualValues.iconAvailableColor);
  root.style.setProperty(
    '--icon-not-available',
    visualValues.iconNotAvailableColor,
  );
  root.style.setProperty(
    '--visual-proposal-link-color',
    visualValues.proposalLinkColor,
  );
  root.style.setProperty(
    '--visual-proposal-link-text-decoration',
    visualValues.proposalLinkTextDecoration,
  );
  root.style.setProperty('--border-standard', visualValues.borderStandardColor);
  root.style.setProperty('--summary-text', visualValues.summaryTextColor);
  root.style.setProperty('--summary-label', visualValues.summaryLabelColor);
  root.style.setProperty(
    '--summary-section-title',
    visualValues.summarySectionTitleColor,
  );
  root.style.setProperty(
    '--visual-summary-quote-id-color',
    visualValues.summaryQuoteIdColor,
  );
  root.style.setProperty(
    '--visual-summary-section-title-font-size',
    visualValues.summarySectionTitleFontSize,
  );
  root.style.setProperty(
    '--visual-summary-price-color',
    visualValues.summaryPriceColor,
  );
  root.style.setProperty(
    '--trip-type-inactive',
    visualValues.tripTypeInactiveColor,
  );
  root.style.setProperty('--visual-button-radius', visualValues.buttonRadius);
  root.style.setProperty(
    '--visual-quotation-button-radius',
    visualValues.quotationButtonRadius,
  );
  root.style.setProperty(
    '--visual-outline-button-color',
    visualValues.outlineButtonColor,
  );
  root.style.setProperty(
    '--visual-outline-button-font-weight',
    visualValues.outlineButtonFontWeight,
  );
  root.style.setProperty(
    '--visual-outline-button-mobile-text-transform',
    visualValues.outlineButtonMobileTextTransform,
  );
  root.style.setProperty(
    '--visual-action-button-width',
    visualValues.actionButtonWidth,
  );
  root.style.setProperty(
    '--visual-action-button-max-width',
    visualValues.actionButtonMaxWidth,
  );
  root.style.setProperty(
    '--visual-product-card-button-min-width',
    visualValues.productCardButtonMinWidth,
  );
  root.style.setProperty(
    '--visual-trip-type-button-padding',
    visualValues.tripTypeButtonPadding,
  );
  root.style.setProperty(
    '--visual-submit-button-padding',
    visualValues.submitButtonPadding,
  );
  root.style.setProperty(
    '--visual-traveller-age-input-height',
    visualValues.travellerAgeInputHeight,
  );
  root.style.setProperty(
    '--visual-outlined-input-radius',
    visualValues.outlinedInputRadius,
  );
  root.style.setProperty(
    '--visual-proposal-grouped-button-radius',
    visualValues.proposalGroupedButtonRadius,
  );
  root.style.setProperty(
    '--visual-proposal-table-card-radius',
    visualValues.proposalTableCardRadius,
  );
  root.style.setProperty(
    '--visual-proposal-table-border',
    visualValues.proposalTableBorder,
  );
  root.style.setProperty(
    '--visual-proposal-table-hover-border',
    visualValues.proposalTableHoverBorder,
  );
  root.style.setProperty(
    '--visual-proposal-tooltip-radius',
    visualValues.proposalTooltipRadius,
  );
  root.style.setProperty(
    '--visual-proposal-tooltip-padding',
    visualValues.proposalTooltipPadding,
  );
  root.style.setProperty(
    '--visual-proposal-tooltip-offset',
    visualValues.proposalTooltipOffset,
  );
  root.style.setProperty(
    '--visual-proposal-table-description-radius',
    visualValues.proposalTableDescriptionRadius,
  );
  root.style.setProperty(
    '--visual-proposal-table-description-padding',
    visualValues.proposalTableDescriptionPadding,
  );
  root.style.setProperty(
    '--visual-proposal-promo-message-padding',
    visualValues.proposalPromoMessagePadding,
  );
  root.style.setProperty(
    '--visual-text-field-radius',
    visualValues.textFieldRadius,
  );
  root.style.setProperty(
    '--visual-traveller-muted-color',
    visualValues.travellerMutedColor,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-border',
    visualValues.travellerIconButtonBorder,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-color',
    visualValues.travellerIconButtonColor,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-hover-bg',
    visualValues.travellerIconButtonHoverBg,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-bg',
    visualValues.travellerIconButtonBg,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-radius',
    visualValues.travellerIconButtonRadius,
  );
  root.style.setProperty(
    '--visual-traveller-icon-button-size',
    visualValues.travellerIconButtonSize,
  );
  root.style.setProperty(
    '--visual-summary-card-border',
    visualValues.summaryCardBorder,
  );
  root.style.setProperty(
    '--visual-summary-card-radius',
    visualValues.summaryCardRadius,
  );
  root.style.setProperty(
    '--visual-summary-box-margin-bottom',
    visualValues.summaryBoxMarginBottom,
  );
  root.style.setProperty(
    '--visual-agent-script-background',
    visualValues.agentScriptBackground,
  );
  root.style.setProperty(
    '--visual-agent-script-shadow',
    visualValues.agentScriptShadow,
  );
  root.style.setProperty(
    '--visual-agent-script-padding',
    visualValues.agentScriptPadding,
  );
  root.style.setProperty(
    '--visual-agent-script-opacity',
    visualValues.agentScriptOpacity,
  );
  root.style.setProperty(
    '--visual-product-card-button-radius',
    visualValues.productCardButtonRadius,
  );
  root.style.setProperty(
    '--visual-summary-divider-margin',
    visualValues.summaryDividerMargin,
  );
};
